export const getFeedbackNav = () => {
  var _document$getElements;
  return (_document$getElements = document.getElementsByClassName('dc-sct-feedback__nav')) === null || _document$getElements === void 0 ? void 0 : _document$getElements[0];
};